(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerFormDataReportController', CompanyCustomerFormDataReportController);

    CompanyCustomerFormDataReportController.$inject = ['$scope', '$state', 'CompanyCustomerFormDataReportSearch', 'CompanyCustomerFormDataReportCustom', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$rootScope', '$uibModal', 'Principal', 'DialogService', '$mdDialog', 'CompanyCustomerCustom', '$localStorage', '$window'];

    function CompanyCustomerFormDataReportController($scope, $state, CompanyCustomerFormDataReportSearch, CompanyCustomerFormDataReportCustom, ParseLinks, AlertService, pagingParams, paginationConstants, $rootScope, $uibModal, Principal, DialogService, $mdDialog, CompanyCustomerCustom, $localStorage, $window) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;


        vm.editCompanyCustomerData = editCompanyCustomerData;
        vm.searchIntakeForms = search;
        vm.clearSearch = clearSearch;
        vm.filterQuery = {};

        //must set in cache
        vm.pageSize = 10;
        vm.pageSizeList = [10, 20, 50];
        vm.isSearching = false;
        vm.pageSizeChanged = pageSizeChanged;
        vm.openEditDataDialog = openEditDataDialog;
        vm.companyCustomForms = [];
        vm.printItem = printItem;

        loadData();

        // loadAll_paging();


        function loadData() {
            filterCompanyCustomerData();
            getAllCompanyCustomForms();
        }

        function getAllCompanyCustomForms() {
            CompanyCustomerCustom.getAllCompanyCustomForm().query(function (result) {
                vm.companyCustomForms = result;
            })
        }

        function loadAll_paging() {

            if (pagingParams.search) {
                CompanyCustomerDataSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanyCustomerDataSearch.query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.CompanyCustomerDatas = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getCompanyCustomerDataPagesByQuery(vm.filterQuery);
            else
                getCompanyCustomerDataPagesByQuery();

        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.pageNumber = 0;
            vm.transition();
        }


        function search() {

            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                vm.advancedSearch();
            }
        }


        function clearSearch() {
            vm.filterQuery.searchText = null;
            filterCompanyCustomerData_Global();
        }

        function newCompanyCustomerData() {

            var result;

            result = Principal.hasSpecialFeatureAccess("invoice");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.go('supplierPanel-v2.newCompanyCustomerData');
        }


        function editCompanyCustomerData(CompanyCustomerData) {
            if (CompanyCustomerData.status == 'TEMP')
                $state.go('supplierPanel-v2.editCompanyCustomerData', {id: CompanyCustomerData.id});
            if (CompanyCustomerData.status == 'UNPAID' || CompanyCustomerData.status == 'SETTLEMENT' || CompanyCustomerData.status == 'VOID')
                $state.go('supplierPanel-v2.CompanyCustomerDataDetail', {id: CompanyCustomerData.id});

        }


        vm.advancedSearch = function () {
            clear();
            vm.filterQuery.searchMode = true;
            filterCompanyCustomerData();
        }

        function pageSizeChanged() {
            clear();
            filterOrderBag();
        }

        function getCompanyCustomerDataPagesByQuery(customFilter) {

            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.pageNumber = vm.page - 1;
            else
                filterQuery.pageNumber = 0;


            filterQuery.pageSize = vm.pageSize; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.pageSize;

            CompanyCustomerFormDataReportCustom.searchCompanyCustomerFormDataReportByQueryPage().save(filterQuery, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyCustomerDatas = data;
                vm.isSearching = false;

                gotToTop();
                // vm.page = vm.filterQuery.pageNumber+1;
            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }


        function gotToTop() {
            // window.scroll(0, 0);
            if (vm.page > 1) {
                document.getElementsByClassName("topOfList")[0].scrollIntoView();
                document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
            }
        }

        function filterCompanyCustomerData_Global() {
            vm.filterQuery.searchMode = true;
            filterCompanyCustomerData();
            clear();

        }

        function filterCompanyCustomerData(customFilter) {

            if (vm.isSearching)
                return;
            getCompanyCustomerDataPagesByQuery(customFilter);
        }


        function printItem(companyCustomerData) {

            var url = $state.href('supplierPanel-v2.reportExport.company_customer_form_data_report.print', {id: companyCustomerData.id});
            $window.open(url, '_blank');
        }


        ComponentIntakeDataDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', 'columnCount'];

        function ComponentIntakeDataDialogController($scope, $mdDialog, dialogData, columnCount) {

            var $ctrl2 = this;
            $ctrl2.customerFormData = dialogData;
            $ctrl2.columnCount = null;
            $ctrl2.columnCount = columnCount;

            $ctrl2.save = function () {


                $ctrl2.customerFormData.companyCustomer.formsData = null;
                if (!$ctrl2.customerFormData.intakeData) {

                    CompanyCustomerCustom.companyCustomerFormData().save($ctrl2.customerFormData, function (result) {
                        loadAll();
                    });

                } else {

                    CompanyCustomerCustom.companyCustomerFormData().update($ctrl2.customerFormData, function (result) {
                        loadAll();
                    });

                }

                $mdDialog.hide();

            };

            $ctrl2.cancel = function () {
                $mdDialog.cancel();
            };

            $ctrl2.getContainerClass = function () {
                if ($localStorage.sideMenuStatus == 'close')
                    return 'container-wide';
                if ($localStorage.sideMenuStatus == 'open')
                    return 'container-small';
            };


        }

        function openEditDataDialog(customerFormData) {

            var columnCount = 4;
            $mdDialog.show({
                locals: {dialogData: customerFormData, columnCount: columnCount},
                controller: ComponentIntakeDataDialogController,
                templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
                controllerAs: '$ctrl',
                // parent: angular.element(document.body),
                targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });
        };


        //Filter Dialog
        var ShowFilterDialogController = function ($scope, $mdDialog, dialogData, $mdSelect) {
            var $ctrl = this;
            $ctrl.data = dialogData;
            $ctrl.okModal = okModal;
            $ctrl.closeModal = closeModal;
            $ctrl.clearFilter = clearFilter;


            //for closing the select box
            document.body.onclick = function (e) {
                $mdSelect.hide();
            }

            function okModal() {
                $mdDialog.hide($ctrl.data);
            }

            function closeModal() {
                $mdDialog.cancel();
            }

            function clearFilter() {
                $ctrl.data.filterQuery = {};
            }

        };
        ShowFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', '$mdSelect'];

        vm.showFilterDialog = function () {

            var dialogData_ = {};
            dialogData_.companyCustomForms = vm.companyCustomForms;
            dialogData_.filterQuery = vm.filterQuery;


            $mdDialog.show({
                locals: {dialogData: dialogData_},
                controller: ShowFilterDialogController,
                templateUrl: 'app/reports/company-customer-form-data-report/filter-company-customer-form-data-report-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: dialogData_,
                clickOutsideToClose: true,
                size: 'lg',
                fullscreen: false

            })
                .then(function (data) {
                    setFilterQuery(data.filterQuery);
                    vm.advancedSearch();
                }, function () {
                });
        }

        function setFilterQuery(filter) {
            vm.filterQuery = filter;
            countFilters();
        }

        function countFilters() {

            vm.filterCount = 0;
            var date = new Date();

            if (vm.filterQuery.companyCustomFormId)
                vm.filterCount++;
        }

        //..................................
    }
})();
